import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './CompanyPage.module.css'

import { mbWay1, way1 } from '../../assets/images/company/companyImages';
import Map from '../../components/Map/Map';

const WayPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="company" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="company" />
        </div>
        <div className='com-content-wrap mt-245'>
          <div className='mb-50' style={{minHeight:'650px'}}>
            <div>
              <div id='map-div' className={S.mapDiv}>
                <Map />
              </div>
              {isMobile() ? (
                <>
                  <img src={mbWay1} className={S.mapContentImg} />  
                </>
              ) : (
                <>
                  <img src={way1} className={S.mapContentImg} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WayPage;
